// fensu.js
import { median, std } from 'mathjs'

/**
 * 对一维或二维数值数组进行标准化打分
 * @param {number[] | number[][]} abc - 输入数组（一维或二维）
 * @param {boolean} reverse - 是否反向归一（默认true：值越大，分越低）
 * @returns {number[] | number[][]}
 */
export function robustNormalize(abc, reverse = true) {
  const is2D = Array.isArray(abc[0]);

  if (!is2D) {
    return process1D(abc, reverse);
  } else {
    // 按列处理
    const cols = transpose(abc);
    const scoredCols = cols.map(col => process1D(col, reverse));
    return transpose(scoredCols);
  }
}

/**
 * 对一维数组执行 fensu 逻辑
 * @param {number[]} X - 输入数组
 * @param {boolean} reverse - 是否反向归一
 * @returns {number[]} - 分数
 */
function process1D(X, reverse = true) {
  const X_mean = median(X);
  const X_mad = median(X.map(v => Math.abs(v - X_mean)));
  const X_std = std(X);

  const X_max = X_mean + 5 * X_mad;
  const X_min = X_mean - 5 * X_mad;

  const X_clipped = X.map(v => Math.max(Math.min(v, X_max), X_min));
  const X_return = X_clipped.map(v => (v - X_mean) / X_std);

  const r_max = Math.max(...X_return);
  const r_min = Math.min(...X_return);

  const x_fensu = X_return.map(v =>
    reverse
      ? (r_max - v) / (r_max - r_min)
      : (v - r_min) / (r_max - r_min)
  );

  return x_fensu;
}

/**
 * 转置二维数组
 * @param {Array[]} matrix
 * @returns {Array[]}
 */
function transpose(matrix) {
  return matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex]));
}
